import ActionTypes from "../action-types";
import { GTM_EVENTS } from "../track-params";

/**
 * @module Facebook
 * @class
 * @internal
 */
class Facebook {
    constructor(options = {}) {
        this.options = options;
        this.name = "Facebook";
        this.optOut = false;
        this.script = "//www.facebook.com/tr?id=1463534503955550&ev=AddToCart&noscript=1&cd[content_type]=product&cd[content_ids]="
    }

    /**
     *
     * @method pageView
     * @param {String} eventName
     * @param {Object} params
     * @returns {Promise}
     * @internal
     */
     
    pageView(...args) {
        // Create the event.
        return this.track(...args);
    }

    /**
     *
     * @method track
     * @param {String} eventName
     * @param {Object} params
     * @returns {Promise}
     * @internal
     */

    track(eventName, params) {
        try{
            let {event} = params;
            
            switch(event){
                case GTM_EVENTS[ActionTypes.ADD_TO_CART]:
                    let {ecommerce : {add : {products}}} = params;
                    let skus = products.reduce(function(acc, cur){{
                        acc.push(cur.id);
                        return acc;
                    }}, []);
                    let encodeSKU = encodeURIComponent(skus.join(','));
                    new Image().src = this.script + encodeSKU;
                    break;

                default:
            }
        } catch (e){

        }
        
    }

}

export default Facebook;